import { render, staticRenderFns } from "./_template-header.vue?vue&type=template&id=053ecfa4&scoped=true&"
import script from "./_template-header.vue?vue&type=script&lang=js&"
export * from "./_template-header.vue?vue&type=script&lang=js&"
import style0 from "./_template-header.vue?vue&type=style&index=0&id=053ecfa4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "053ecfa4",
  null
  
)

export default component.exports